import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import CampaignsAPI from '../../api/campaigns';
import CampaignFormsAPI from '../../api/campaign_forms';
import BotExpressAPI from '../../api/bot_expresses';

export const state = {
  meta:{
    count: 0,
    currentPage: 1,
    pageSize: 15,
    reports: {
      send: 0,
      failed: 0,
      broadcast_amount: 0,
      recipient: 0
    }
  },
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
  },
  expressBots:[],
  uiFlagsExpressBots: {
    isFetching: false,
  },
  campaignForms:[],
  campaignFormUiFlags:{
    isFetching:false,
    isCreating:false,
    isDeleting:false,
    isUpdating:false,
  },
  formMeta:{
    count: 0,
    current_page: 1,
    page_size: 15,
  },

  // form responders
  formResponders:[],
  formResponderMeta:{
    count: 0,
    current_page: 1,
    page_size: 15,
  },
  formResponderUiFlags:{
    isFetching:false,
    // isCreating:false,
    // isDeleting:false,
    // isUpdating:false,
  },
};

export const getters = {
  getMeta(_state) {
    return _state.meta;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getCampaigns: _state => campaignType => {
    return _state.records.filter(
      record => record.campaign_type === campaignType
    );
  },
  getAllCampaigns: _state => {
    return _state.records;
  },
  getUIFlagsExpressBot(_state) {
    return _state.uiFlagsExpressBots;
  },
  getExpressBots: _state => {
    return _state.expressBots;
  },
  // forms
  getFormMeta(_state) {
    return _state.formMeta;
  },
  getUIFlagsForms(_state) {
    return _state.campaignFormUiFlags;
  },
  getCampaignForms: _state => {
    return _state.campaignForms;
  },

  // form responders
  getFormResponders: _state => {
    return _state.formResponders;
  },
  getFormResponderMeta(_state) {
    return _state.formResponderMeta;
  },
  getUIFlagsFormResponders(_state) {
    return _state.formResponderUiFlags;
  },


};

export const actions = {
  getPageByCampaigns: async ({ commit },queryParams) => {
    commit(types.SET_CAMPAIGN_UI_FLAG, { isFetching: true });
    try {
      const {data} = await CampaignsAPI.campaignsByPage(queryParams);
      commit(types.SET_CAMPAIGNS_BY_PAGE, {data:data?.payload, page:queryParams.page, count: data?.meta?.count,meta:data?.meta});
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_CAMPAIGN_UI_FLAG, { isFetching: false });
    }
  },
  get: async function getCampaigns({ commit }) {
    commit(types.SET_CAMPAIGN_UI_FLAG, { isFetching: true });
    try {
      const response = await CampaignsAPI.get();
      commit(types.SET_CAMPAIGNS, response.data?.payload);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_CAMPAIGN_UI_FLAG, { isFetching: false });
    }
  },
  create: async function createCampaign({ commit }, campaignObj) {
    commit(types.SET_CAMPAIGN_UI_FLAG, { isCreating: true });
    try {
      const response = await CampaignsAPI.create(campaignObj);
      commit(types.ADD_CAMPAIGN, response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CAMPAIGN_UI_FLAG, { isCreating: false });
    }
  },
  update: async ({ commit }, { id, ...updateObj }) => {
    commit(types.SET_CAMPAIGN_UI_FLAG, { isUpdating: true });
    try {
      const response = await CampaignsAPI.update(id, updateObj);
      commit(types.EDIT_CAMPAIGN, response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CAMPAIGN_UI_FLAG, { isUpdating: false });
    }
  },
  delete: async ({ commit }, id) => {
    commit(types.SET_CAMPAIGN_UI_FLAG, { isDeleting: true });
    try {
      await CampaignsAPI.delete(id);
      commit(types.DELETE_CAMPAIGN, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CAMPAIGN_UI_FLAG, { isDeleting: false });
    }
  },
  fetchExpressBots: async ({ commit },) => {
    commit(types.SET_EXPRESSBOT_UI_FLAG, { isFetching: true });
    try {
      const {data} = await BotExpressAPI.getBotExpressList();
      if (data.data) {
        commit(types.SET_EXPRESSBOTS, data.data);
      }
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_EXPRESSBOT_UI_FLAG, { isFetching: false });
    }
  },
  // create campaign form
  createCampaignForm: async function createCampaignForm({ commit,state }, payload) {
    commit(types.SET_CAMPAIGN_FORMS_UI_FLAG, { isCreating: true });
    try {
      const response = await CampaignFormsAPI.createCampaignForm(payload);
      const newList = [
        response.data,
        ...state.campaignForms,
      ]
      commit(types.SET_CAMPAIGN_FORMS, newList);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CAMPAIGN_FORMS_UI_FLAG, { isCreating: false });
    }
  },
  updateCampaignForm: async function updateCampaignForm({ commit,state }, {campaignFormId,payload}) {
    commit(types.SET_CAMPAIGN_FORMS_UI_FLAG, { isUpdating: true });
    try {
      const response = await CampaignFormsAPI.updateCampaignFormById(campaignFormId,payload);
      const newList = state.campaignForms.map(item => {
        if(item.id === campaignFormId){
          return response.data;
        }
        return item;
      });
      commit(types.SET_CAMPAIGN_FORMS, newList);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CAMPAIGN_FORMS_UI_FLAG, { isUpdating: false });
    }
  },
  deleteCampaignForm: async function deleteCampaignForm({ commit,state }, {form_id}) {
    commit(types.SET_CAMPAIGN_FORMS_UI_FLAG, { isDeleting: true });
    try {
      await CampaignFormsAPI.deleteCampaignFormById(form_id);
      const newList = state.campaignForms.filter(item => item.id !== form_id);
      commit(types.SET_CAMPAIGN_FORMS, newList);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_CAMPAIGN_FORMS_UI_FLAG, { isDeleting: false });
    }
  },

  fetchCampaignForms: async function({commit,state},query){
    commit(types.SET_CAMPAIGN_FORMS_UI_FLAG, { isFetching: true });
    try {
      const {data} = await CampaignFormsAPI.fetchCampaignForms(query);
      const newMeta = {...state.formMeta,...data.meta};
      commit(types.SET_CAMPAIGN_FORMS, data.data);
      commit(types.SET_CAMPAIGN_FORMS_META, newMeta);
      commit(types.SET_CAMPAIGN_FORMS_UI_FLAG, { isFetching: false });
    } catch (error) {
      // Ignore error
      commit(types.SET_CAMPAIGN_FORMS_UI_FLAG, { isFetching: false });
      throw error;
    }
  },

  toggleCampaignFormPublish: async function({commit,state}, {form_id,}){
    commit(types.SET_CAMPAIGN_FORMS_UI_FLAG, { isUpdating: true });
    try {
      await CampaignFormsAPI.toggleCampaignFormPublish(form_id,);
      const newList = state.campaignForms.map(item => {
        if(item.id === form_id){
          return {
            ...item,
            published: !item.published,
          }
        }
        return item;
      });
      commit(types.SET_CAMPAIGN_FORMS, newList);
      commit(types.SET_CAMPAIGN_FORMS_UI_FLAG, { isUpdating: false });
    } catch (error) {
      throw new Error(error);
      commit(types.SET_CAMPAIGN_FORMS_UI_FLAG, { isUpdating: false });
    }
  },

  // form responders
  fetchFormResponders: async function({commit,state},{form_id,query}){
    commit(types.SET_CMPN_FORMS_RESPONDER_UI_FLAG, { isFetching: true });
    try {
      const {data} = await CampaignFormsAPI.fetchFormRespondersById(form_id,query);
      const newMeta = {...state.formResponderMeta,...data.meta};
      commit(types.SET_CMPN_FORMS_RESPONDERS, data.data);
      commit(types.SET_CMPN_FORMS_RESPONDER_META, newMeta);
    } catch (error) {
      // Ignore error
      throw error;
    }finally{
      commit(types.SET_CMPN_FORMS_RESPONDER_UI_FLAG, { isFetching: false });
    }
  }



};

export const mutations = {
  [types.SET_CAMPAIGN_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.ADD_CAMPAIGN]: MutationHelpers.create,
  [types.SET_CAMPAIGNS]: MutationHelpers.set,
  [types.EDIT_CAMPAIGN]: MutationHelpers.update,
  [types.DELETE_CAMPAIGN]: MutationHelpers.destroy,

  // mutation page wise
  [types.SET_CAMPAIGNS_BY_PAGE]: ($state,{data,page, count,meta})=>{
    $state.records = data;
    $state.meta = {
      ...$state.meta,
      currentPage: page,
      count,
      reports:meta.reports,
    }
  },

  // express bot mutation
  [types.SET_EXPRESSBOT_UI_FLAG](_state, data) {
    _state.uiFlagsExpressBots = {
      ..._state.uiFlagsExpressBots,
      ...data,
    };
  },
  [types.SET_EXPRESSBOTS](_state, data) {
    _state.expressBots = data;
  },

  // campaign forms
  [types.SET_CAMPAIGN_FORMS_UI_FLAG](_state, data) {
    _state.campaignFormUiFlags = {
      ..._state.campaignFormUiFlags,
      ...data,
    };
  },
  [types.SET_CAMPAIGN_FORMS_META](_state, data) {
    _state.formMeta = data;
  },
  [types.SET_CAMPAIGN_FORMS](_state, data) {
    _state.campaignForms = data;
  },

  // form responders
  [types.SET_CMPN_FORMS_RESPONDER_UI_FLAG](_state, data) {
    _state.formResponderUiFlags = {
      ..._state.formResponderUiFlags,
      ...data,
    };
  },
  [types.SET_CMPN_FORMS_RESPONDER_META](_state, data) {
    _state.formResponderMeta = data;
  },
  [types.SET_CMPN_FORMS_RESPONDERS](_state, data) {
    _state.formResponders = data;
  },
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
